import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pdf-data-loading" }
const _hoisted_2 = {
  key: 0,
  class: "pdf-data-onloading-box"
}
const _hoisted_3 = { class: "onloading-icon" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

import { Document, Search, Back } from '@element-plus/icons-vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { getAppPDFStatus, PDF_STATUS, retryCut } from "@/request/appCenter";
import { PollingTimer } from '@/utils/pollingTimer';


export default /*@__PURE__*/_defineComponent({
  __name: 'GetPDFDataLoading',
  props: {
  pdfId: {
    type: String,
    default: ''
  }
},
  emits: ['step-prev', 'step-next'],
  setup(__props, { emit: __emit }) {

const emits = __emit
const props = __props
const CHECKING_STATUS = {
  SUCCESS: 0,
  FAILED: 1,
  LOADING: 2,
  ERROR: 3,
}
const status = ref(CHECKING_STATUS.LOADING)
const errorMessage = ref("")
const successCountDown = ref(3)

let pollingTimer: any = null;

const startDelayStepNext = () => {
  const timer = setInterval(() => {
    successCountDown.value--;
    if (successCountDown.value === 0) {
      clearInterval(timer);
      emits('step-next');
    }
  }, 1000);
}

const checkStatus = async () => {
  try {
    const res = await getAppPDFStatus(props.pdfId);
    const { code, data, msg } = res.data
    if (code === 200) {
      if (data.status >= PDF_STATUS.EXTRACTED) {
        status.value = CHECKING_STATUS.SUCCESS;
        startDelayStepNext()
        return true
      } else return false
    } else {
      status.value = CHECKING_STATUS.FAILED;
      errorMessage.value = msg;
      console.warn('查询状态失败', msg);
      return
    }
  } catch (error) {
    status.value = CHECKING_STATUS.ERROR;
    console.warn('查询状态失败', error);
    return;
  }
};

const handleRetry = () => {
  // 状态为 FAILED 时，重新解析
  if (status.value === CHECKING_STATUS.FAILED) {
    retryCut(props.pdfId);
  }
  pollingTimer.start();
  status.value = CHECKING_STATUS.LOADING;
}

onMounted(() => {
  pollingTimer = new PollingTimer(checkStatus, 1500);
  pollingTimer.start();
});

onUnmounted(() => {
  pollingTimer.cancel();
  pollingTimer = null;
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (status.value === CHECKING_STATUS.LOADING)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_icon, {
              size: 140,
              class: "onloading-icon-doc"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Document))
              ]),
              _: 1
            }),
            _createVNode(_component_el_icon, {
              size: 70,
              class: "onloading-icon-search"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Search))
              ]),
              _: 1
            })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "onloading-text" }, "正在获取PDF数据，请稍后...", -1)),
          _createVNode(_component_el_button, {
            class: "onloading-btn",
            type: "primary",
            plain: "",
            icon: _unref(Back),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('step-prev')))
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("后台等待，继续上传")
            ])),
            _: 1
          }, 8, ["icon"])
        ]))
      : (status.value === CHECKING_STATUS.SUCCESS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_result, {
              icon: "success",
              title: "提取成功",
              "sub-title": `PDF数据提取完成，即将跳转下一步（${successCountDown.value}）`
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('step-next')))
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("立即跳转")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["sub-title"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_result, {
              icon: "error",
              title: status.value === CHECKING_STATUS.FAILED ? '提取出错' : '网络出错',
              "sub-title": errorMessage.value
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: handleRetry
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(status.value === CHECKING_STATUS.FAILED ? '重新解析' : '重试'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title", "sub-title"])
          ]))
  ]))
}
}

})